import type { TypePolicies } from '@apollo/client';

/**
 * Shared Apollo cache type policies.
 *
 * Applied identically to both the main and inventory Apollo clients.
 * Primarily used to teach Apollo how to normalize entities whose primary key
 * field isn't named `id` — without these, mutation responses can't update
 * list/detail caches automatically, forcing every mutation to `refetch()`.
 *
 * For page-based pagination (page + pageSize args), we rely on Apollo's
 * default keyArgs behavior: each distinct arg combination caches separately.
 * No custom `merge` functions are needed; going page-1 → page-2 → back-to-page-1
 * serves the original page 1 from cache.
 */
export const typePolicies: TypePolicies = {
  // TransactionOrder uses `transaction` as its primary key, not `id`.
  // Without this, mutation responses can't normalize into list/detail caches,
  // so callers have to `refetch()` after every save.
  TransactionOrder: { keyFields: ['transaction'] },

  UserType: {
    fields: {
      groups: {
        // Replace existing groups array on every fetch rather than merging.
        merge(_existing, incoming) {
          return incoming;
        },
      },
    },
  },
};
